export default __webpack_public_path__ + "static/media/byod-needs-to-spell-security.baa82a1f.jpg";